export default "__VITE_ASSET__DWGRXdhz__"